/**
 * Scope & Location API Client
 * REST endpoints for scopes (tracking areas) and locations within projects.
 * Falls back to fixture data when API is unavailable.
 */

import apiClient from './api';
import { getScopes } from '../fixtures/seedData';

// Scopes
export const fetchScopes = async (projectId) => {
  try {
    return await apiClient.get(`/projects/${projectId}/scopes`);
  } catch {
    console.warn('[FIXTURE] fetchScopes fallback for', projectId);
    return getScopes(projectId);
  }
};

export const createScope = async (projectId, data) => {
  try {
    return await apiClient.post(`/projects/${projectId}/scopes`, data);
  } catch {
    console.warn('[FIXTURE] createScope fallback — scope not persisted');
    return { item: { ...data, id: `fixture-scope-${Date.now()}` } };
  }
};

export const updateScope = async (projectId, scopeId, data) => {
  try {
    return await apiClient.put(`/projects/${projectId}/scopes/${scopeId}`, data);
  } catch {
    console.warn('[FIXTURE] updateScope fallback — scope not persisted');
    return { item: { ...data, id: scopeId } };
  }
};

// Locations
export const fetchLocations = async (projectId, scopeId) => {
  try {
    return await apiClient.get(`/projects/${projectId}/scopes/${scopeId}/locations`);
  } catch {
    console.warn('[FIXTURE] fetchLocations fallback for', projectId, scopeId);
    const scopes = getScopes(projectId).items || [];
    const scope = scopes.find((s) => s.id === scopeId);
    return { items: scope?.locations || [] };
  }
};

export const createLocation = async (projectId, scopeId, data) => {
  try {
    return await apiClient.post(`/projects/${projectId}/scopes/${scopeId}/locations`, data);
  } catch {
    console.warn('[FIXTURE] createLocation fallback — location not persisted');
    return { item: { ...data, id: `fixture-loc-${Date.now()}` } };
  }
};
